import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MessageService } from 'primeng/api';
import { ProjectFormService } from '../../../../services/projectform.service';

@Component({
  selector: 'app-create-form-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule
  ],
  providers: [MessageService],
  templateUrl: './create-form-modal.html',
  styleUrl: './create-form-modal.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateFormModalComponent implements OnInit {
  folderId!: number;
  formName: string = '';
  loading: boolean = false;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private projectFormService: ProjectFormService,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.folderId = this.config.data?.folderId;
  }

  createForm(): void {
    if (!this.formName.trim()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please enter a form name'
      });
      return;
    }

    this.loading = true;
    const request = {
      formFolderId: this.folderId,
      name: this.formName.trim()
    };

    this.projectFormService.createProjectForm(request).subscribe({
      next: (form) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Form created successfully'
        });
        this.ref.close(form);
      },
      error: (error) => {
        console.error('Error creating form:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to create form'
        });
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  cancel(): void {
    this.ref.close();
  }
}
